import * as API from "@/services/API";

export default {
  getMain(Id) {
    return API.apiClient.get(`/colors/${Id}`);
  },
  getMains(Id) {
    return API.apiClient.get(`/colors/${Id}`);
  },
  updateMain(Id, payload) {
    return API.apiClient.put(`/colors/${Id}`, payload);
  },
};
